<div class="row" *ngIf="isGenderComponentVisible">
    <div class="col-22 bottom-10">
        <ValidatedRadioButtonGroup [label]="isSpanish ? '¿Cuál es tu género actual? (opcional)' : 'What is your gender? Select one. (optional)'"
                                   [labelClass]="(isSpanish || enrollmentgenderPrefyViewModel.isPhoneEnrollment) ? 'blue-text' : ''"
                                   [options]="currentGenderOptions" [radioGroupName]="'rCurrentGender'"
                                   (onValueChange)="currentGenderChanged($event)"
                                   [selectedValue]="enrollmentgenderPrefyViewModel.CURRENTGENDER">
        </ValidatedRadioButtonGroup>

        <div class="col-7 otherbox">
            <ValidatedTextField class="" [maxlength]="25" *ngIf="iscurrentGenderOther" [label]="" id="txtCurrentGender"
                                [text]="enrollmentgenderPrefyViewModel.CURRENTGENDEROTH"
                                (onValueChange)="enrollmentgenderPrefyViewModel.CURRENTGENDEROTH = $event">

            </ValidatedTextField>

        </div>
    </div>
</div>
<div class="row" *ngIf="isGenderComponentVisible">
    <div class="col-22  bottom-10">
        <ValidatedRadioButtonGroup [label]="isSpanish ? '¿Cuál de las siguientes opciones representa mejor cómo piensas de timismo? (opcional)' : 'Which of the following best represents how you think of yourself? Select one. (optional)'"
                                   [labelClass]="(isSpanish || enrollmentgenderPrefyViewModel.isPhoneEnrollment) ? 'blue-text' : ''"
                                   [options]="repYourSelfOptions" [radioGroupName]="'rRepYourSelf'" (onValueChange)="yourSelfChanged($event)"
                                   [selectedValue]="enrollmentgenderPrefyViewModel.GENDERNPRONOUN">
        </ValidatedRadioButtonGroup>
        <div class="col-7 otherbox">
            <ValidatedTextField class="" [maxlength]="25" *ngIf="isyourSelfOther" [label]="" id="txtRepYourSelf"
                                [text]="enrollmentgenderPrefyViewModel.GENDERNPRONOUNOTH"
                                (onValueChange)="enrollmentgenderPrefyViewModel.GENDERNPRONOUNOTH = $event">

            </ValidatedTextField>
        </div>
    </div>
</div>